import Image from "next/image";
import Link from "next/link";

const renderBlock = ({ imgUrl, imgAlt, head, copy, blogUrl, blogId }) => {
  return (
    <div className="col">
      <div className="image-wrapper">
        <Link href={blogUrl} id={`blog-thumb-link-${blogId}`} target="_blank">
          <Image
            style={{ objectFit: "cover" }}
            src={imgUrl}
            alt={imgAlt}
            width={236}
            height={175}
          />
        </Link>
      </div>
      <div className="text-wrapper">
        <h5 className="heading heading-sm">
          <Link href={blogUrl} id={`blog-title-link-${blogId}`} target="_blank">
            {head}
          </Link>
        </h5>
        <p className="body--sm">{copy}</p>
      </div>
    </div>
  );
};

const LearnFrom = ({ head, block1, block2, block3, block4 }) => {
  return (
    <section className="learn-from full">
      <div className="learn-from__banner banner">
        <div className="learn-from__copy">
          <div className="section-header">
            <h3 className="heading heading--md"> {head} </h3>
          </div>
          <div className="cols">
            {renderBlock(block1)}
            {renderBlock(block2)}
            {renderBlock(block3)}
            {renderBlock(block4)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LearnFrom;
